export default __webpack_public_path__ + "static/media/HowTo.9a383530.gif";